import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const inviteContentGrid = style({
  display: "grid",
  gridTemplateColumns: "1fr",
  rowGap: vars.space.m,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },
});

export const gridDivider = style({
  gridColumn: "1 / span 2",
  padding: `${vars.space.m} 0`,
});

const gridItem = style({
  gridColumn: "span 1",
  gridColumnStart: 1,
});

export const sectionWrapper = style([
  gridItem,
  {
    display: "grid",
    gap: vars.space.m,
  },
]);

export const codeWrapper = style({
  display: "grid",
  gap: vars.space.xs,
});

export const codeText = style({
  fontSize: vars.fontSizes.heading.xl,
});

export const emailTextStyles = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  borderRadius: vars.radii.s,
  backgroundColor: vars.colors.surfaceVariant,
  padding: vars.space.m,
});
